import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useTierUsageSubscription } from 'hooks/useTierUsageSubscription'
import { observer } from 'mobx-react-lite'
import { useCallback, useEffect, useRef } from 'react'
import { useRootStore } from 'stores/RootStore'

export const TieredUsageListener = observer(() => {
  const workspaceId = useCurrentWorkspaceId()
  const tierUsageStore = useRootStore().tierUsageStore
  const prevWorkspaceIdRef = useRef(workspaceId)

  useEffect(() => {
    if (prevWorkspaceIdRef.current !== workspaceId) {
      tierUsageStore.reset()
      prevWorkspaceIdRef.current = workspaceId
    }

    tierUsageStore.fetchedWorkspaceId = workspaceId
    tierUsageStore.refetch(workspaceId)
  }, [tierUsageStore, workspaceId])

  const handleTierUpdate = useCallback(
    (tierUsage: Parameters<typeof tierUsageStore.setTierInfo>[0]) => {
      if (tierUsageStore.fetchedWorkspaceId === workspaceId) {
        tierUsageStore.setTierInfo(tierUsage)
      }
    },
    [tierUsageStore, workspaceId],
  )

  const handlePlanUpdate = useCallback(() => {
    if (tierUsageStore.fetchedWorkspaceId === workspaceId) {
      tierUsageStore.refetch(workspaceId)
    }
  }, [tierUsageStore, workspaceId])

  useTierUsageSubscription({
    workspaceId,
    onUpdate: handleTierUpdate,
    onPlanUpdate: handlePlanUpdate,
  })

  return null
})
